import React from 'react';
import { Button, Dropdown, Modal, Message } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ExportButton from '../../../../../components/export/exportButton';
import css from '../../../chart-list.module.css';

export const SportsClubsWarningModal = ({ display, open, onClose, organization, chart, inventory, process }) => {
    const { t } = useTranslation();
    const history = useHistory();

    if (!display) {
        return null;
    }
    return (
        <Modal
            size="extralarge"
            title={t('ticket.charts.inventory.action_export_lfp')}
            open={open}
            onClose={onClose}
            submitButton={
                <Button
                    primary
                    label={t('ticket.charts.inventory.lfpModal.button_setup_inventory')}
                    onClick={() => {
                        history.push(`/ticket/O${organization.id}/charts/${chart.pk}/inventories/${inventory.uuid}`);
                    }}
                />
            }
            cancelButton={
                <div className={css['lfp-export-modal-btn']}>
                    <SportsClubExportButton process={process} showButton display organization={organization} chart={chart} inventory={inventory} />
                </div>
            }
        >
            <Message title={t('ticket.charts.inventory.lfpModal.message_title')} type="warning">
                {t('ticket.charts.inventory.lfpModal.message_description')}
                <ul className={css['warning-modal-message-list']}>
                    <li>{t('ticket.charts.inventory.lfpModal.message_description_option_1')}</li>
                    <li>{t('ticket.charts.inventory.lfpModal.message_description_option_2')}</li>
                </ul>
            </Message>
        </Modal>
    );
};

SportsClubsWarningModal.defaultProps = {
    display: false,
    open: false,
    process: 'lfp_export',
    onClose: () => {}
};

SportsClubsWarningModal.propTypes = {
    display: PropTypes.bool,
    open: PropTypes.bool,
    onclose: PropTypes.func.isRequired,
    process: PropTypes.string,
    organization: PropTypes.object.isRequired,
    chart: PropTypes.object.isRequired,
    inventory: PropTypes.object.isRequired
};

export const SportsClubExportButton = ({ display, process, showButton = false, onClick = () => {}, organization, chart, inventory }) => {
    const { t } = useTranslation();
    if (!display) {
        return <Dropdown.Item item={t('ticket.charts.inventory.action_export_lfp')} onClick={onClick} />;
    }

    return (
        <ExportButton
            showButton={showButton}
            buttonTrans={`ticket.charts.inventory.${showButton ? 'lfpModal.button_export' : 'action_export_lfp'}`}
            path={`/ticket/organizations/${organization.id}/charts/${chart.pk}/inventories/${inventory.pk}/export/`}
            choiceProcess={process}
            chart={chart}
            inventory={inventory}
        />
    );
};

SportsClubExportButton.defaultProps = {
    display: false,
    showButton: false,
    process: 'lfp_export',
    onClick: () => {}
};

SportsClubExportButton.propTypes = {
    display: PropTypes.bool,
    showButton: PropTypes.bool,
    onclic: PropTypes.func.isRequired,
    process: PropTypes.string,
    organization: PropTypes.object.isRequired,
    chart: PropTypes.object.isRequired,
    inventory: PropTypes.object.isRequired
};
